const reducers = {
    greenfield (res) {
        const doc = {};
        doc.address = {
            endereco: res.logradouro,
            bairro: res.neighborhood,
            cidade: res.county,
            uf: res.federativeUnit,
            regiao: res.region,
            cep: res.cep,
            pma: res.pmaName
        };

        doc.information = {
            nome: res.pointName,
            tipo: res.pointType ? `${res.pointType.name} — ${res.pointType.description}` : '',
            tier: res.pointTier ? `${res.pointTier.name} — ${res.pointTier.description}` : '',
            ano: res.yearReference
        };

        doc.location = {
            latitude: res.latitude,
            longitude: res.longitude
        };

        return doc;
    }
};

export default reducers;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/newGreenfield/reducers.js